// extracted by mini-css-extract-plugin
export default {"pageTitle":"PageTitle_pageTitle__vX6rz"};